export const filenameFormatter = (value: string) => {
  if (value.length > 20) {
    return (
      value.substr(0, 10) + "..." + value.substr(value.length - 5, value.length)
    );
  }
  return value;
};
